import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  postProfileUpdate,
  type PostProfileUpdateParams,
  type PostProfileUpdateResponse,
} from '@services/UsersService';

export type UsePostProfileUpdateParams = {
  mutationOptions?: SWRMutationConfiguration<
    PostProfileUpdateResponse,
    unknown,
    string,
    PostProfileUpdateParams,
    PostProfileUpdateResponse
  >;
};

export const postProfileUpdateMutationKey = 'post-profile-update';

export const usePostProfileUpdate = ({
  mutationOptions,
}: UsePostProfileUpdateParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PostProfileUpdateResponse,
    unknown,
    string,
    PostProfileUpdateParams
  >(
    postProfileUpdateMutationKey,
    (_url, { arg }) => postProfileUpdate(arg),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
